import type { IconName } from '../lib/icons'
import { ICON_PATHS } from './icons/paths'

/**
 * One Phosphor duotone glyph, drawn inline.
 *
 * `aria-hidden` and `focusable="false"` on every one, without exception and without a prop to turn it
 * off. An icon in this console never carries meaning on its own: the rail's buttons have a `title`
 * and a visible label on the phone tabs, and every toolbar button has its word beside it. Letting a
 * caller mark one as meaningful would invite the case where it is the only thing saying what a
 * control does, which is the version a screen reader cannot read out.
 *
 * `fill="currentColor"` rather than a color prop, so the rail's active/inactive opacity and
 * `var(--accent-line)` reach it through ordinary inheritance and a palette switch repaints it with
 * no JavaScript - the same property that makes the charts work (D-173).
 */
export function Icon({ name, size = 16, className }: { name: IconName; size?: number; className?: string }) {
  const paths = ICON_PATHS[name]

  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 256 256"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
    >
      {/* The tinted shape, then the line work over it. This is the duotone weight's construction. */}
      <path d={paths.duotone} opacity="0.2" />
      <path d={paths.solid} />
    </svg>
  )
}
